import { Theme } from '@material-ui/core';
import { makeStyles } from '@material-ui/styles';

export default makeStyles((theme: Theme) => ({
  table: {
    fontFamily: theme.typography.fontFamily,
    fontSize: theme.typography.fontSize,
    fontWeight: theme.typography.fontWeightRegular,
  },
  tableContainer: {
    borderRadius: theme.spacing(1),
    backgroundColor: theme.palette.background.default,
    width: 'fit-content',
    margin: theme.spacing(2),
    padding: theme.spacing(2),
    boxShadow: theme.shadows[1],
  },
}));
